export const clientId = 'X0Fa_BzVRdyQjc7C3fHdMw';
export const clientSecret = '8opKaxICQn6wW5U4f7Vr9gP87TJkrgSRWfBcWfqjWiRw';
export const server = 'https://platform.devtest.ringcentral.com';
export const username = '+14703940058';
export const password = 'S4ndb0x#';
export const extension = '101';
